import {FlotService} from '../../services/FlotService';

import './overview.html';
import './tabs/tab-overview.html';
import './tabs/tab-currency.html';
import './tabs/tab-country.html';
import './tabs/tab-group.html';
import './tabs/tab-bank.html';
import './tabs/charts/pieChartCurrency.html';
import './tabs/charts/pieChartBank.html';
import './tabs/charts/mapChartCountry.html';
import './tabs/charts/barChartHistory.html';
import './tabs/consolidation-currency-dropdown.html'
import { CommonViewController } from "../../controller/CommonViewController";

/**
 *
 * @param $scope
 * @param fsMainDependencies
 * @param sessionPersistance
 */
export const TAB_OVERVIEW = 'overview';
export const TAB_CURRENCY = 'currency';
export const TAB_COUNTRY = 'country';
export const TAB_BANK = 'bank';
export const TAB_GROUP = 'group';
export const TAB_ACCOUNT = 'account';

export class arsAccountsController  extends CommonViewController {
    constructor($scope, userService, arsMainDependencies){
        super($scope, userService, arsMainDependencies);
        this.flotService = new FlotService(arsMainDependencies.document, userService, this.state);
        delete this.ftsMainDependencies.$rootScope.checkElements;
        // available tabs
        $scope.tabs = [
                { id: TAB_OVERVIEW, label: 'UNGROUPED', state: 'app.accounts' },
                { id: TAB_CURRENCY, label: 'BY_CURRENCY', state: 'app.accountsByCurrency'},
                { id: TAB_COUNTRY, label: 'BY_COUNTRY',  state: 'app.accountsByCountry'},
                { id: TAB_BANK, label: 'BY_BANK', state: 'app.accountsByBank' },
                { id: TAB_GROUP, label: 'BY_OWN_GROUP', state: 'app.accountsByGroup' }
        ];

        const selectedTab = $scope.tabs.filter((tab) => tab.id === this.state.params.tabName);
        $scope.selectedIndex = $scope.tabs.indexOf(selectedTab[0]);
        $scope.visibleTab = selectedTab[0].id;
    }


}
